var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 15.4778H16.4863L16.0922 15.0979C16.9719 14.0765 17.6149 12.8733 17.9751 11.5745C18.3352 10.2758 18.4037 8.91346 18.1756 7.58515C17.514 3.674 14.2481 0.550711 10.3065 0.0723698C8.92075 -0.102836 7.51328 0.041097 6.19177 0.493154C4.87026 0.945211 3.66974 1.69341 2.68207 2.6805C1.6944 3.66759 0.945766 4.86741 0.493443 6.18814C0.0411211 7.50888 -0.102896 8.91552 0.0724122 10.3004C0.551034 14.2397 3.67616 17.5037 7.5896 18.1649C8.91869 18.3929 10.2818 18.3245 11.5813 17.9645C12.8809 17.6046 14.0847 16.962 15.1068 16.0827L15.4869 16.4767V17.5881L21.4696 23.5674C22.0468 24.1442 22.99 24.1442 23.5671 23.5674C24.1443 22.9906 24.1443 22.0479 23.5671 21.4711L17.5984 15.4778ZM9.15216 15.4778C5.64695 15.4778 2.81745 12.6499 2.81745 9.14679C2.81745 5.64364 5.64695 2.8158 9.15216 2.8158C12.6574 2.8158 15.4869 5.64364 15.4869 9.14679C15.4869 12.6499 12.6574 15.4778 9.15216 15.4778Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.322ebfaecf673cc275741f9dc962960c.svg";
export { ForwardRef as ReactComponent };